<script>
  import { fade } from "svelte/transition";
  import { redirect } from "../../pager";
  import "../../../node_modules/croppie/croppie.css";
  import Croppie from "croppie";
  import Alert from "../../components/Alert.svelte";
  import Navigationbar from "../../components/Navigationbar.svelte";
  import FileInput from "../../components/FileInput/FileInput.svelte";
  import Title from "../../components/Title.svelte";
  import Modal from "../../components/Modal.svelte";
  import Select from "svelte-select";
  import format from "number-format.js";
  import { imask } from "svelte-imask";
  const RpNumber = {
    mask: "Rp num",
    blocks: {
      num: {
        mask: Number,
        thousandsSeparator: ".",
        min: 1,
      },
    },
  };
  const GrNumber = {
    mask: "num",

    blocks: {
      num: {
        mask: Number,
        thousandsSeparator: ".",
        min: 1,
      },
    },
  };
  function hargaMask({ detail: imask }) {
    require.harga = imask.unmaskedValue;
  }
  function beratMask({ detail: imask }) {
    require.berat = imask.unmaskedValue;
  }

  //liblary
  import axios from "axios";

  //setting
  import { session } from "../../components/js/notif.js";
  let settings;
  session.subscribe((value) => {
    settings = value;
  });

  export let data;

  let loading = false;
  let alias = "";
  let id = "";
  if (data) {
    alias = data.alias;
    id = data.id;
  }
  //scroll to top every page load
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });

  //navigation
  let navigation = [];
  if (settings.loggedin == true) {
    if (settings.data.pen != undefined) {
      navigation["message"] = settings.data.pen.nm;
    } else {
      navigation["message"] = "Selamat Datang";
    }
  } else {
    navigation["message"] = "Selamat Datang";
  }

  //alert
  let alert = [];
  let uid = Math.random().toString(36).substring(2);

  function loadingBtn(e) {
    let el = this;
    el.setAttribute("disabled", "disabled");
    let reset = e.srcElement.innerHTML;
    this.innerHTML = "Memproses...";
    setTimeout(() => {
      el.innerHTML = reset;
      el.removeAttribute("disabled");
    }, 10000);
  }

  $: image1source = false;
  $: image2source = false;
  $: image3source = false;
  $: image4source = false;
  $: image5source = false;
  let categories = [];

  //FORM Data Payload
  $: image2 = false;
  $: image3 = false;
  $: image4 = false;
  $: image5 = false;

  let require;

  $: require = {
    image1: false,
    category: undefined,
    namaproduk: "",
    berat: "",
    harga: "",
    deskripsi: "",
  };
  let number;
  $: number = {
    berat: require.berat,
    harga: require.harga,
  };
  //#FORM Data Payload

  let errorForm = [];
  function validator() {
    errorForm = [];
    for (var k in require) {
      if (document.getElementById(k + "-labelwarning")) {
        document.getElementById(k + "-labelwarning").style = "";
      }
      if (document.getElementById(k + "-warning")) {
        document.getElementById(k + "-warning").style.display = "none";
        document.getElementById(k + "-warning").innerHTML = "";
      }
      if (
        require[k] !== undefined &&
        require[k] !== null &&
        require[k] !== "" &&
        require[k] !== false
      ) {
      } else {
        errorForm = [...errorForm, { field: k, message: "Mohon diisi" }];
        if (document.getElementById(k + "-warning")) {
          document.getElementById(k + "-warning").style.display =
            "inline-block";
          document.getElementById(k + "-warning").innerHTML = "Mohon diisi";
        }
        if (document.getElementById(k + "-labelwarning")) {
          document.getElementById(k + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }

    for (var n in number) {
      document.getElementById(n + "-warning").style.display = "none";
      document.getElementById(n + "-labelwarning").style = "";
      document.getElementById(n + "-warning").innerHTML = "";
      if (/^\+?(0|[1-9]\d*)$/.test(number[n])) {
      } else {
        errorForm = [
          ...errorForm,
          { field: n, message: "Pastikan Hanya Angka" },
        ];
        if (document.getElementById(n + "-warning")) {
          document.getElementById(n + "-warning").style.display =
            "inline-block";
          document.getElementById(n + "-warning").innerHTML =
            "Pastikan Hanya Angka";
        }
        if (document.getElementById(n + "-labelwarning")) {
          document.getElementById(n + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }

    if (errorForm.length > 0) {
      return false;
    } else {
      return true;
    }
  }

  function handleSubmit(thenAction) {
    loading = true;
    let payload;
    let valid = validator();
    if (valid) {
      if (data) {
        payload = {
          id: id,
          alias: alias,
          name: require.namaproduk,
          price: require.harga,
          description: require.deskripsi,
          weight: require.berat,
          category: require.category.value,
          image1: require.image1,
          image2: image2,
          image3: image3,
          image4: image4,
          image5: image5,
        };
      } else {
        payload = {
          name: require.namaproduk,
          price: require.harga,
          description: require.deskripsi,
          weight: require.berat,
          category: require.category.value,
          image1: require.image1,
          image2: image2,
          image3: image3,
          image4: image4,
          image5: image5,
        };
      }
      axios
        .post(
          settings.url + "/sipade/productAdd?authorization=" + settings.token,
          payload
        )
        .then(function (response) {
          alert = [
            ...alert,
            {
              title: "Dekatan",
              message: response.data.message,
              color: "green",
            },
          ];
          if (thenAction == 1) {
            if (data) {
              redirect("/tokoku/add");
            } else {
              window.location.reload();
            }
          } else {
            redirect("/belanja/" + response.data.data.domain);
          }
        })
        .catch(function (error) {
          loading = false;
          if (error.response.status == 401) {
            localStorage.removeItem("t");
            redirect("/login");
          } else {
            if (error.response.data.message) {
              alert = [
                ...alert,
                {
                  title: "Dekatan",
                  message: error.response.data.message,
                  color: "orange",
                },
              ];
            } else {
              alert = [
                ...alert,
                {
                  title: "Dekatan",
                  message: "Anda belum terhubung dengan baik",
                  color: "orange",
                },
              ];
            }
          }
        });
    } else {
      loading = false;
      console.error("Belum Terisi Semua");

      alert = [
        ...alert,
        {
          title: "Dekatan",
          message: "Ada kolom wajib yang belum diisi",
          color: "orange",
        },
      ];
    }
  }

  function handleDelete() {
    loading = true;
    let payload = {
      id: id,
    };
    axios
      .post(
        settings.url + "/sipade/productDelete?authorization=" + settings.token,
        payload
      )
      .then(function (response) {
        alert = [
          ...alert,
          {
            title: "Dekatan",
            message: response.data.message,
            color: "green",
          },
        ];
        loading = false;
        setTimeout(() => {
          redirect("/belanja/" + response.data.data.domain);
        }, 5000);
      })
      .catch(function (error) {
        loading = false;
        if (error.response.status == 401) {
          localStorage.removeItem("t");
          redirect("/login");
        } else {
          if (error.response.data.message) {
            alert = [
              ...alert,
              {
                title: "Dekatan",
                message: error.response.data.message,
                color: "orange",
              },
            ];
          } else {
            alert = [
              ...alert,
              {
                title: "Dekatan",
                message: "Anda belum terhubung dengan baik",
                color: "orange",
              },
            ];
          }
        }
      });
  }
  axios
    .get(settings.url + "/sipade/categories", {
      params: {
        authorization: settings.token,
      },
    })
    .then(function (response) {
      categories = response.data;
    })
    .catch(function (error) {
      alert = [...alert, { message: "Masalah Komunikasi Data", color: "red" }];
    })
    .then(function () {
      // always executed
    });

  function SetImage() {
    loading = true;
    if (require.image1) {
      document.getElementById("imgTumb1").innerHTML =
        '<img alt="img-product" class="object-contain rounded-lg" src="' +
        require.image1 +
        '">';
      document.getElementById("image-blank-1").style.display = "none";
      document.getElementById("image-fill-1").style.display = "block";
    } else {
      document.getElementById("imgTumb1").innerHTML = " ";
      document.getElementById("image-blank-1").style.display = "block";
      document.getElementById("image-fill-1").style.display = "none";
    }
    if (image2) {
      document.getElementById("imgTumb2").innerHTML =
        '<img alt="img-product" class="object-contain rounded-lg" src="' +
        image2 +
        '">';
      document.getElementById("image-blank-2").style.display = "none";
      document.getElementById("image-fill-2").style.display = "block";
    } else {
      document.getElementById("imgTumb2").innerHTML = " ";
      document.getElementById("image-blank-2").style.display = "block";
      document.getElementById("image-fill-2").style.display = "none";
    }
    if (image3) {
      document.getElementById("imgTumb3").innerHTML =
        '<img alt="img-product" class="object-contain rounded-lg" src="' +
        image3 +
        '">';
      document.getElementById("image-blank-3").style.display = "none";
      document.getElementById("image-fill-3").style.display = "block";
    } else {
      document.getElementById("imgTumb3").innerHTML = " ";
      document.getElementById("image-blank-3").style.display = "block";
      document.getElementById("image-fill-3").style.display = "none";
    }
    if (image4) {
      document.getElementById("imgTumb4").innerHTML =
        '<img alt="img-product" class="object-contain rounded-lg" src="' +
        image4 +
        '">';
      document.getElementById("image-blank-4").style.display = "none";
      document.getElementById("image-fill-4").style.display = "block";
    } else {
      document.getElementById("imgTumb4").innerHTML = " ";
      document.getElementById("image-blank-4").style.display = "block";
      document.getElementById("image-fill-4").style.display = "none";
    }
    if (image5) {
      document.getElementById("imgTumb5").innerHTML =
        '<img alt="img-product" class="object-contain rounded-lg" src="' +
        image5 +
        '">';
      document.getElementById("image-blank-5").style.display = "none";
      document.getElementById("image-fill-5").style.display = "block";
    } else {
      document.getElementById("imgTumb5").innerHTML = " ";
      document.getElementById("image-blank-5").style.display = "block";
      document.getElementById("image-fill-5").style.display = "none";
    }
    loading = false;
  }

  let cropCrop;
  let binaryData;
  let orientation = 1;
  let cropEl = document.getElementById("imgCrop");

  let cropImage = "1";

  function destroyCrop() {
    if (!cropCrop) return;
    cropCrop.destroy();
    cropCrop = null;
  }

  function initCrop() {
    if (cropCrop) return;

    cropCrop = new Croppie(document.querySelector("#imgCrop"), {
      viewport: { width: 300, height: 300 },
      boundary: { width: "100%", height: "70vh" },
      showZoomer: true,
      enableOrientation: true,
    });
  }

  function handleFileSelect(file) {
    var f = file.detail.files[0]; // FileList object
    if (f) {
      if (/(jpe?g|png|gif)$/i.test(f.type)) {
        if (f.size > 10292969) {
          alert = [
            ...alert,
            {
              message: "File yang dapat diproses maks 300Kb",
              color: "orange",
            },
          ];
        } else {
          var reader = new FileReader();

          // Closure to capture the file information.
          reader.onload = (function (theFile) {
            return function (e) {
              binaryData = e.target.result;
              if (cropImage == "1") {
                image1source = binaryData;
              }
              if (cropImage == "2") {
                image2source = binaryData;
              }
              if (cropImage == "3") {
                image3source = binaryData;
              }
              if (cropImage == "4") {
                image4source = binaryData;
              }
              if (cropImage == "5") {
                image5source = binaryData;
              }

              document.getElementById("imgCropModal").style.display = "block";
              SetImage();
              cropEl = document.getElementById("imgCrop");

              cropEl.style.display = "block";
              document.getElementById("imgCropmenu").style.display = "block";
              initCrop();

              cropCrop.bind({ zoom: 0, url: binaryData });

              document.getElementById(
                "image-blank-" + cropImage
              ).style.display = "none";
              document.getElementById("image-fill-" + cropImage).style.display =
                "block";
            };
          })(f);
          reader.readAsDataURL(f);
        }
      } else {
        alert = [
          ...alert,
          {
            message: "File yang dapat diproses berupa .jpg,jpeg,png,gif",
            color: "orange",
          },
        ];
      }
    } else {
      alert = [
        ...alert,
        {
          message: "File tidak ditemukan",
          color: "orange",
        },
      ];
    }
  }
  function cropRotateR() {
    cropCrop.rotate(90);
  }
  function cropRotateL() {
    cropCrop.rotate(-90);
  }
  function cropFlipx() {
    orientation = orientation == 1 ? 2 : 1;
    cropCrop.bind({ zoom: 0, url: binaryData, orientation: orientation });
  }
  function cropFlipy() {
    orientation = orientation == 1 ? 4 : 1;
    cropCrop.bind({ zoom: 0, url: binaryData, orientation: orientation });
  }
  let cropRes;
  function cropResult() {
    cropCrop
      .result({
        type: "base64",
        format: "png",
        size: { width: 600, height: 600, quality: 1 },
      })
      .then(function (imgcroped) {
        cropRes = imgcroped;
        if (cropImage == "1") {
          require.image1 = cropRes;
        }
        if (cropImage == "2") {
          image2 = cropRes;
        }
        if (cropImage == "3") {
          image3 = cropRes;
        }
        if (cropImage == "4") {
          image4 = cropRes;
        }
        if (cropImage == "5") {
          image5 = cropRes;
        }
        SetImage();
        document.getElementById("imgCropModal").style.display = "none";

        destroyCrop();
      });
  }

  let cropDisplay = "block";
  let cropmenuDisplay = "flex";
  function cropClose() {
    cropEl.style.display = "none";
    document.getElementById("imgCropModal").style.display = "none";
    initCrop();
  }

  function cropCloseX() {
    cropEl.style.display = "none";
    document.getElementById("imgCropModal").style.display = "none";
    SetImage();
  }
  function cropOpen() {
    cropEl = document.getElementById("imgCrop");
    document.getElementById("imgCropmenu").style.display = "block";
    cropEl.style.display = "block";
    document.getElementById("imgCropModal").style.display = "block";
    initCrop();
    if (cropImage == "1") {
      cropCrop.bind({ zoom: 0, url: image1source });
    }
    if (cropImage == "2") {
      cropCrop.bind({ zoom: 0, url: image2source });
    }
    if (cropImage == "3") {
      cropCrop.bind({ zoom: 0, url: image3source });
    }
    if (cropImage == "4") {
      cropCrop.bind({ zoom: 0, url: image4source });
    }
    if (cropImage == "5") {
      cropCrop.bind({ zoom: 0, url: image5source });
    }
  }

  $: lengthCount = require.namaproduk.length;

  $: lengthDescriptionCount = require.deskripsi.length;

  const toDataURL = (url) =>
    fetch(url, { mode: "no-cors" })
      .then((response) => response.blob())
      .then(
        (blob) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          })
      );
  let notfound = false;
  if (data) {
    loading = true;
    axios
      .get(settings.url + "/warga/product/" + alias + "-" + id, {
        params: {
          authorization: settings.token,
        },
      })
      .then(function (response) {
        if (response.data) {
          require = {
            namaproduk: response.data.data.basic.name,
            berat: response.data.data.basic.weight,
            harga: response.data.data.basic.price,
            deskripsi: response.data.data.basic.description,
            category: {
              label: response.data.data.category.title,
              value: response.data.data.category.ID,
            },
          };

          if (response.data.data.pictures[0]) {
            toDataURL(
              "https://pics.dekatan.com/" +
                response.data.data.pictures[0].fileName
            ).then((dataUrl) => {
              loading = true;
              require.image1 = dataUrl;
              image1source = dataUrl;
              SetImage();
            });
          }
          if (response.data.data.pictures[1]) {
            toDataURL(
              "https://pics.dekatan.com/" +
                response.data.data.pictures[1].fileName
            ).then((dataUrl) => {
              loading = true;
              image2 = dataUrl;
              image2source = dataUrl;
              SetImage();
            });
          }
          if (response.data.data.pictures[2]) {
            toDataURL(
              "https://pics.dekatan.com/" +
                response.data.data.pictures[2].fileName
            ).then((dataUrl) => {
              loading = true;
              image3 = dataUrl;
              image3source = dataUrl;
              SetImage();
            });
          }
          if (response.data.data.pictures[3]) {
            toDataURL(
              "https://pics.dekatan.com/" +
                response.data.data.pictures[3].fileName
            ).then((dataUrl) => {
              loading = true;
              image4 = dataUrl;
              image4source = dataUrl;
              SetImage();
            });
          }
          if (response.data.data.pictures[4]) {
            toDataURL(
              "https://pics.dekatan.com/" +
                response.data.data.pictures[4].fileName
            ).then((dataUrl) => {
              loading = true;
              image5 = dataUrl;
              image5source = dataUrl;
              SetImage();
            });
          }
        }
      })
      .catch(function (error) {
        if (error.response.status == 404) {
          notfound = true;
        } else {
          alert = [
            ...alert,
            { message: "Masalah Komunikasi Data", color: "red" },
          ];
        }
        loading = false;
      })
      .then(function () {
        setTimeout(() => {
          loading = false;
        }, 10000);
      });
  }
</script>

<svelte:head>
  <title>Kelola Produk - Dekatan</title>
</svelte:head>
{#if alert.length > 0}
  <div class="fixed bottom-0 right-0 z-50 px-2 mb-10">
    {#each alert as a}
      <Alert color={a.color} message={a.message} />
    {/each}
  </div>
{/if}
{#if data}
  <Navigationbar
    backbtn="true"
    message={navigation["message"]}
    title="Kelola Produk"
    align="center"
  />
{:else}
  <Navigationbar
    backbtn="true"
    message={navigation["message"]}
    title="Tambah Produk"
    align="center"
  />
{/if}
<main transition:fade class="container px-2 pt-24 mx-auto mb-20 lg:pt-24">
  {#if loading}
    <div
      class="fixed top-0 left-0 right-0 z-50 w-screen h-2 bg-green-500 animate-pulse"
    />
  {/if}
  {#if notfound}
    <div
      class="w-full max-w-3xl px-10 py-20 mx-auto mt-32 text-center bg-white rounded-full rounded-br-none shadow-lg lg:w-1/2 rounded-rt-lg"
    >
      <div class="my-10">
        <h2 class="text-3xl">Oops, salah alamat</h2>
        <p class="pb-5 text-gray-500">
          Sepertinya kamu tersesat, yuk kembali ke beranda
        </p>
        <a
          href="./"
          class="px-24 py-2 text-xl text-white bg-blue-400 rounded-lg"
          >Kembali</a
        >
      </div>
    </div>
  {:else}
    <div class="max-w-3xl px-3 py-5 mx-auto bg-white rounded-lg shadow-lg">
      <div class="flex flex-wrap mx-auto wrap-extended">
        <div class="w-full p-6 pt-0" id="cropContainer">
          <Title
            subtitle="Pastikan produk Anda sudah sesuai dengan syarat dan ketentuan yang berlaku"
            title="Kelola Produk"
            tipe="2"
          />
          <label for="image" class="block text-sm font-light"
            >Gambar Produk</label
          >
          <div
            id="imgCropModal"
            class="fixed bottom-0 left-0 z-50 w-full h-screen bg-gray-200"
            style="display:none"
          >
            <div id="imgCropmenu" class="hidden h-auto m-2">
              <div
                class="flex justify-between px-4 py-2 text-lg font-bold text-center border-b border-gray-400"
              >
                <span class="py-1 text-gray-700">Editor Gambar</span><span
                  class="p-1 cursor-pointer"
                  on:click={cropCloseX}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    ><path
                      d="M14 12l5.544-5.544c.584-.583.61-1.511.06-2.06-.549-.55-1.476-.523-2.06.06L12.002 10 6.456 4.456c-.583-.583-1.51-.61-2.06-.06-.55.549-.523 1.477.06 2.06L10.001 12l-5.545 5.544c-.583.583-.61 1.511-.06 2.06.55.55 1.477.523 2.06-.06L12.001 14l5.543 5.544c.584.583 1.511.61 2.06.06.55-.549.524-1.477-.06-2.06L14.002 12z"
                      fill="#6C727C"
                    /></svg
                  ></span
                >
              </div>
              <div id="imgCropmenuhide" class="flex justify-center gap-1 my-2">
                <button
                  class="p-2 text-white bg-green-600 rounded focus:bg-gray-500 focus:outline-none"
                  on:click={cropResult}
                  on:click={destroyCrop}
                  on:click={cropClose}>Simpan</button
                >
                <button
                  class="p-2 text-white bg-orange-600 rounded focus:bg-gray-500 focus:outline-none"
                  on:click={cropRotateR}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    ><path
                      d="M19 12c0 3.9-3.1 7-7 7-3.2 0-6-2.2-6.8-5.2-.1-.5.2-1.1.7-1.2.5-.1 1.1.2 1.2.7v.1C7.8 15.5 9.7 17 12 17c2.8 0 5-2.2 5-5s-2.2-5-5-5c-1.3 0-2.5.5-3.4 1.3l1.2 1.2c.2.2 0 .5-.2.5H5.7c-.2 0-.3-.1-.3-.3V5.8c0-.3.3-.4.5-.2l1.3 1.3C8.5 5.7 10.2 5 12 5c3.9 0 7 3.1 7 7z"
                      fill="#fff"
                    /></svg
                  ></button
                >
                <button
                  class="p-2 text-white bg-orange-600 rounded focus:bg-gray-500 focus:outline-none"
                  on:click={cropRotateL}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    ><path
                      d="M5 12c0 3.9 3.1 7 7 7 3.2 0 6-2.2 6.8-5.2.1-.5-.2-1.1-.7-1.2-.5-.1-1.1.2-1.2.7v.1c-.7 2.1-2.6 3.6-4.9 3.6-2.8 0-5-2.2-5-5s2.2-5 5-5c1.3 0 2.5.5 3.4 1.3l-1.2 1.2c-.2.2 0 .5.2.5h3.9c.2 0 .3-.1.3-.3V5.8c0-.3-.3-.4-.5-.2l-1.3 1.3C15.5 5.7 13.8 5 12 5c-3.9 0-7 3.1-7 7z"
                      fill="#fff"
                    /></svg
                  ></button
                >
                <button
                  class="p-2 text-white bg-orange-600 rounded focus:bg-gray-500 focus:outline-none"
                  on:click={cropFlipx}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    ><path
                      d="M10 5.2v13.1c0 .4-.4.7-.9.7H4.8c-.6 0-1.1-.5-.9-1L9.5 5.1c.1-.2.5-.1.5.1zm4.5-.1c-.1-.2-.5-.1-.5.1v13.1c0 .4.4.7.9.7h4.3c.6 0 1.1-.5.9-1L14.5 5.1zM12 3c.3 0 .5.2.5.5v2c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-2c0-.3.2-.5.5-.5zm0 4c.3 0 .5.2.5.5v3c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-3c0-.3.2-.5.5-.5zm0 5c.3 0 .5.2.5.5v3c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-3c0-.3.2-.5.5-.5zm0 5c.3 0 .5.2.5.5v2c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-2c0-.3.2-.5.5-.5z"
                      fill="#fff"
                    /></svg
                  ></button
                >
                <button
                  class="p-2 text-white bg-orange-600 rounded focus:bg-gray-500 focus:outline-none"
                  on:click={cropFlipy}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    ><path
                      d="M18.8 10H5.7c-.4 0-.7-.4-.7-.9V4.8c0-.6.5-1.1 1-.9l12.9 5.6c.2.1.1.5-.1.5zm.1 4.5c.2-.1.1-.5-.1-.5H5.7c-.4 0-.7.4-.7.9v4.3c0 .6.5 1.1 1 .9l12.9-5.6zM21 12c0 .3-.2.5-.5.5h-2c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h2c.3 0 .5.2.5.5zm-4 0c0 .3-.2.5-.5.5h-3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3c.3 0 .5.2.5.5zm-5 0c0 .3-.2.5-.5.5h-3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3c.3 0 .5.2.5.5zm-5 0c0 .3-.2.5-.5.5h-2c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h2c.3 0 .5.2.5.5z"
                      fill="#fff"
                    /></svg
                  ></button
                >
              </div>
            </div>
            <div id="imgCrop" class="h-auto" />
          </div>
          <div class="flex flex-wrap mx-auto wrap-extended">
            <div
              class="relative flex items-center justify-center w-32 mx-auto my-2 overflow-hidden bg-gray-200 border-4 border-gray-300 border-dashed rounded-lg"
              style="height:8rem"
            >
              <div
                id="imgTumb1"
                class="absolute top-0 left-0 w-full overflow-hidden"
              />

              <FileInput
                let:dragging
                multiple={true}
                on:input={handleFileSelect}
              >
                <div
                  on:click={() => (cropImage = "1")}
                  on:drop={() => (cropImage = "1")}
                  class="absolute left-0 top-0 text-blue-900 w-full shadow-lg
                  tracking-wide cursor-pointer text-center {!dragging
                    ? 'font-normal text-xs'
                    : 'font-bold text-sm'}"
                  style="height:8rem"
                >
                  <div
                    style="display:block;"
                    class="absolute w-full h-full pt-6 text-center cursor-pointer"
                    id="image-blank-1"
                  >
                    <svg
                      class="w-8 h-8 mx-auto"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      ><path
                        d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z"
                      /></svg
                    >

                    <span class="font-bold uppercase" id="image1-labelwarning"
                      >Gambar Utama</span
                    ><br />
                    {!dragging ? "Klik Disini" : "Ok Lepaskan"}
                  </div>

                  <div
                    style="display:none; background:rgba(49, 53, 59, 0.68);"
                    class="absolute w-full h-full py-2 text-center text-white transition-all duration-300 ease-in-out transform rounded-lg opacity-50 lg:opacity-0 md:opacity-0 hover:opacity-100"
                    id="image-fill-1"
                  >
                    <div class="absolute bottom-0 right-0 mb-4 mr-2">
                      <span
                        on:click|preventDefault={() => (cropImage = "1")}
                        on:click|preventDefault={cropOpen}
                        class="z-10 inline-block p-1 bg-white rounded-md hover:bg-gray-300"
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 28 28"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="inline"
                          ><rect width="28" height="28" rx="4" fill="#fff" />
                          <path
                            d="M23 20H11c-1.7 0-3-1.3-3-3V5h2v12c0 .6.4 1 1 1h12v2z"
                            fill="#6C727C"
                          />
                          <path
                            d="M10 8H5v2h5V8zm8 3v5h2v-5c0-1.7-1.3-3-3-3h-5v2h5c.6 0 1 .4 1 1zm2 7h-2v5h2v-5z"
                            fill="#6C727C"
                          /></svg
                        ></span
                      >
                      <span
                        on:click|preventDefault={() => (require.image1 = "")}
                        on:click|preventDefault={SetImage}
                        class="z-10 inline-block p-1 bg-white rounded-md hover:bg-gray-300"
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 28 28"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="inline"
                          ><rect width="28" height="28" rx="4" fill="#fff" />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M17 6h3c.55 0 1 .45 1 1v1H7V7c0-.55.45-1 1-1h3c0-.55.45-1 1-1h4c.55 0 1 .45 1 1zm-7 17c-1.1 0-2-.9-2-2V9h12v12c0 1.1-.9 2-2 2h-8z"
                            fill="#6C727C"
                          /></svg
                        ></span
                      >
                    </div>
                    <svg
                      class="w-8 h-8 mx-auto"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      ><path
                        d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z"
                      /></svg
                    >

                    <span class="uppercase">Ganti Gambar</span><br />
                    {!dragging ? "Klik Disini" : "Ok Lepaskan"}
                  </div>
                </div>
              </FileInput>
            </div>

            <div
              class="relative flex items-center justify-center w-32 mx-auto my-2 overflow-hidden bg-gray-200 border-4 border-gray-300 border-dashed rounded-lg"
              style="height:8rem"
            >
              <div
                id="imgTumb2"
                class="absolute top-0 left-0 w-full overflow-hidden"
              />

              <FileInput
                let:dragging
                multiple={true}
                on:input={handleFileSelect}
              >
                <div
                  on:click={() => (cropImage = "2")}
                  on:drop={() => (cropImage = "2")}
                  class="absolute left-0 top-0 text-blue-900 w-full shadow-lg
                  tracking-wide cursor-pointer text-center {!dragging
                    ? 'font-normal text-xs'
                    : 'font-bold text-sm'}"
                  style="height:8rem"
                >
                  <div
                    style="display:block;"
                    class="absolute w-full h-full pt-6 text-center cursor-pointer"
                    id="image-blank-2"
                  >
                    <svg
                      class="w-8 h-8 mx-auto"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      ><path
                        d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z"
                      /></svg
                    >

                    <span class="font-bold uppercase" id="image2-labelwarning"
                      >Depan</span
                    ><br />
                    {!dragging ? "Klik Disini" : "Ok Lepaskan"}
                  </div>

                  <div
                    style="display:none; background:rgba(49, 53, 59, 0.68);"
                    class="absolute w-full h-full py-2 text-center text-white transition-all duration-300 ease-in-out transform rounded-lg opacity-50 lg:opacity-0 md:opacity-0 hover:opacity-100"
                    id="image-fill-2"
                  >
                    <div class="absolute bottom-0 right-0 mb-4 mr-2">
                      <span
                        on:click|preventDefault={() => (cropImage = "2")}
                        on:click|preventDefault={cropOpen}
                        class="z-10 inline-block p-1 bg-white rounded-md hover:bg-gray-300"
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 28 28"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="inline"
                          ><rect width="28" height="28" rx="4" fill="#fff" />
                          <path
                            d="M23 20H11c-1.7 0-3-1.3-3-3V5h2v12c0 .6.4 1 1 1h12v2z"
                            fill="#6C727C"
                          />
                          <path
                            d="M10 8H5v2h5V8zm8 3v5h2v-5c0-1.7-1.3-3-3-3h-5v2h5c.6 0 1 .4 1 1zm2 7h-2v5h2v-5z"
                            fill="#6C727C"
                          /></svg
                        ></span
                      >
                      <span
                        on:click|preventDefault={() => (image2 = "")}
                        on:click|preventDefault={SetImage}
                        class="z-10 inline-block p-1 bg-white rounded-md hover:bg-gray-300"
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 28 28"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="inline"
                          ><rect width="28" height="28" rx="4" fill="#fff" />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M17 6h3c.55 0 1 .45 1 1v1H7V7c0-.55.45-1 1-1h3c0-.55.45-1 1-1h4c.55 0 1 .45 1 1zm-7 17c-1.1 0-2-.9-2-2V9h12v12c0 1.1-.9 2-2 2h-8z"
                            fill="#6C727C"
                          /></svg
                        ></span
                      >
                    </div>
                    <svg
                      class="w-8 h-8 mx-auto"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      ><path
                        d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z"
                      /></svg
                    >

                    <span class="uppercase">Ganti Gambar</span><br />
                    {!dragging ? "Klik Disini" : "Ok Lepaskan"}
                  </div>
                </div>
              </FileInput>
            </div>

            <div
              class="relative flex items-center justify-center w-32 mx-auto my-2 overflow-hidden bg-gray-200 border-4 border-gray-300 border-dashed rounded-lg"
              style="height:8rem"
            >
              <div
                id="imgTumb3"
                class="absolute top-0 left-0 w-full overflow-hidden"
              />

              <FileInput
                let:dragging
                multiple={true}
                on:input={handleFileSelect}
              >
                <div
                  on:click={() => (cropImage = "3")}
                  on:drop={() => (cropImage = "3")}
                  class="absolute left-0 top-0 text-blue-900 w-full shadow-lg
                  tracking-wide cursor-pointer text-center {!dragging
                    ? 'font-normal text-xs'
                    : 'font-bold text-sm'}"
                  style="height:8rem"
                >
                  <div
                    style="display:block;"
                    class="absolute w-full h-full pt-6 text-center cursor-pointer"
                    id="image-blank-3"
                  >
                    <svg
                      class="w-8 h-8 mx-auto"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      ><path
                        d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z"
                      /></svg
                    >

                    <span class="font-bold uppercase" id="image3-labelwarning"
                      >Samping</span
                    ><br />
                    {!dragging ? "Klik Disini" : "Ok Lepaskan"}
                  </div>

                  <div
                    style="display:none; background:rgba(49, 53, 59, 0.68);"
                    class="absolute w-full h-full py-2 text-center text-white transition-all duration-300 ease-in-out transform rounded-lg opacity-50 lg:opacity-0 md:opacity-0 hover:opacity-100"
                    id="image-fill-3"
                  >
                    <div class="absolute bottom-0 right-0 mb-4 mr-2">
                      <span
                        on:click|preventDefault={() => (cropImage = "3")}
                        on:click|preventDefault={cropOpen}
                        class="z-10 inline-block p-1 bg-white rounded-md hover:bg-gray-300"
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 28 28"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="inline"
                          ><rect width="28" height="28" rx="4" fill="#fff" />
                          <path
                            d="M23 20H11c-1.7 0-3-1.3-3-3V5h2v12c0 .6.4 1 1 1h12v2z"
                            fill="#6C727C"
                          />
                          <path
                            d="M10 8H5v2h5V8zm8 3v5h2v-5c0-1.7-1.3-3-3-3h-5v2h5c.6 0 1 .4 1 1zm2 7h-2v5h2v-5z"
                            fill="#6C727C"
                          /></svg
                        ></span
                      >
                      <span
                        on:click|preventDefault={() => (image3 = "")}
                        on:click|preventDefault={SetImage}
                        class="z-10 inline-block p-1 bg-white rounded-md hover:bg-gray-300"
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 28 28"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="inline"
                          ><rect width="28" height="28" rx="4" fill="#fff" />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M17 6h3c.55 0 1 .45 1 1v1H7V7c0-.55.45-1 1-1h3c0-.55.45-1 1-1h4c.55 0 1 .45 1 1zm-7 17c-1.1 0-2-.9-2-2V9h12v12c0 1.1-.9 2-2 2h-8z"
                            fill="#6C727C"
                          /></svg
                        ></span
                      >
                    </div>
                    <svg
                      class="w-8 h-8 mx-auto"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      ><path
                        d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z"
                      /></svg
                    >

                    <span class="uppercase">Ganti Gambar</span><br />
                    {!dragging ? "Klik Disini" : "Ok Lepaskan"}
                  </div>
                </div>
              </FileInput>
            </div>

            <div
              class="relative flex items-center justify-center w-32 mx-auto my-2 overflow-hidden bg-gray-200 border-4 border-gray-300 border-dashed rounded-lg"
              style="height:8rem"
            >
              <div
                id="imgTumb4"
                class="absolute top-0 left-0 w-full overflow-hidden"
              />

              <FileInput
                let:dragging
                multiple={true}
                on:input={handleFileSelect}
              >
                <div
                  on:click={() => (cropImage = "4")}
                  on:drop={() => (cropImage = "4")}
                  class="absolute left-0 top-0 text-blue-900 w-full shadow-lg
                  tracking-wide cursor-pointer text-center {!dragging
                    ? 'font-normal text-xs'
                    : 'font-bold text-sm'}"
                  style="height:8rem"
                >
                  <div
                    style="display:block;"
                    class="absolute w-full h-full pt-6 text-center cursor-pointer"
                    id="image-blank-4"
                  >
                    <svg
                      class="w-8 h-8 mx-auto"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      ><path
                        d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z"
                      /></svg
                    >

                    <span class="font-bold uppercase" id="image4-labelwarning"
                      >Atas</span
                    ><br />
                    {!dragging ? "Klik Disini" : "Ok Lepaskan"}
                  </div>

                  <div
                    style="display:none; background:rgba(49, 53, 59, 0.68);"
                    class="absolute w-full h-full py-2 text-center text-white transition-all duration-300 ease-in-out transform rounded-lg opacity-50 lg:opacity-0 md:opacity-0 hover:opacity-100"
                    id="image-fill-4"
                  >
                    <div class="absolute bottom-0 right-0 mb-4 mr-2">
                      <span
                        on:click|preventDefault={() => (cropImage = "4")}
                        on:click|preventDefault={cropOpen}
                        class="z-10 inline-block p-1 bg-white rounded-md hover:bg-gray-300"
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 28 28"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="inline"
                          ><rect width="28" height="28" rx="4" fill="#fff" />
                          <path
                            d="M23 20H11c-1.7 0-3-1.3-3-3V5h2v12c0 .6.4 1 1 1h12v2z"
                            fill="#6C727C"
                          />
                          <path
                            d="M10 8H5v2h5V8zm8 3v5h2v-5c0-1.7-1.3-3-3-3h-5v2h5c.6 0 1 .4 1 1zm2 7h-2v5h2v-5z"
                            fill="#6C727C"
                          /></svg
                        ></span
                      >
                      <span
                        on:click|preventDefault={() => (image4 = "")}
                        class="z-10 inline-block p-1 bg-white rounded-md hover:bg-gray-300"
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 28 28"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="inline"
                          ><rect width="28" height="28" rx="4" fill="#fff" />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M17 6h3c.55 0 1 .45 1 1v1H7V7c0-.55.45-1 1-1h3c0-.55.45-1 1-1h4c.55 0 1 .45 1 1zm-7 17c-1.1 0-2-.9-2-2V9h12v12c0 1.1-.9 2-2 2h-8z"
                            fill="#6C727C"
                          /></svg
                        ></span
                      >
                    </div>
                    <svg
                      class="w-8 h-8 mx-auto"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      ><path
                        d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z"
                      /></svg
                    >

                    <span class="uppercase">Ganti Gambar</span><br />
                    {!dragging ? "Klik Disini" : "Ok Lepaskan"}
                  </div>
                </div>
              </FileInput>
            </div>

            <div
              class="relative flex items-center justify-center w-32 mx-auto my-2 overflow-hidden bg-gray-200 border-4 border-gray-300 border-dashed rounded-lg"
              style="height:8rem"
            >
              <div
                id="imgTumb5"
                class="absolute top-0 left-0 w-full overflow-hidden"
              />

              <FileInput
                let:dragging
                multiple={true}
                on:input={handleFileSelect}
              >
                <div
                  on:click={() => (cropImage = "5")}
                  on:drop={() => (cropImage = "5")}
                  class="absolute left-0 top-0 text-blue-900 w-full shadow-lg
                  tracking-wide cursor-pointer text-center {!dragging
                    ? 'font-normal text-xs'
                    : 'font-bold text-sm'}"
                  style="height:8rem"
                >
                  <div
                    style="display:block;"
                    class="absolute w-full h-full pt-6 text-center cursor-pointer"
                    id="image-blank-5"
                  >
                    <svg
                      class="w-8 h-8 mx-auto"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      ><path
                        d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z"
                      /></svg
                    >

                    <span class="font-bold uppercase" id="image5-labelwarning"
                      >Detail</span
                    ><br />
                    {!dragging ? "Klik Disini" : "Ok Lepaskan"}
                  </div>

                  <div
                    style="display:none; background:rgba(49, 53, 59, 0.68);"
                    class="absolute w-full h-full py-2 text-center text-white transition-all duration-300 ease-in-out transform rounded-lg opacity-50 lg:opacity-0 md:opacity-0 hover:opacity-100"
                    id="image-fill-5"
                  >
                    <div class="absolute bottom-0 right-0 mb-4 mr-2">
                      <span
                        on:click|preventDefault={() => (cropImage = "5")}
                        on:click|preventDefault={cropOpen}
                        class="z-10 inline-block p-1 bg-white rounded-md hover:bg-gray-300"
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 28 28"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="inline"
                          ><rect width="28" height="28" rx="4" fill="#fff" />
                          <path
                            d="M23 20H11c-1.7 0-3-1.3-3-3V5h2v12c0 .6.4 1 1 1h12v2z"
                            fill="#6C727C"
                          />
                          <path
                            d="M10 8H5v2h5V8zm8 3v5h2v-5c0-1.7-1.3-3-3-3h-5v2h5c.6 0 1 .4 1 1zm2 7h-2v5h2v-5z"
                            fill="#6C727C"
                          /></svg
                        ></span
                      >
                      <span
                        on:click|preventDefault={() => (image5 = "")}
                        class="z-10 inline-block p-1 bg-white rounded-md hover:bg-gray-300"
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 28 28"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="inline"
                          ><rect width="28" height="28" rx="4" fill="#fff" />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M17 6h3c.55 0 1 .45 1 1v1H7V7c0-.55.45-1 1-1h3c0-.55.45-1 1-1h4c.55 0 1 .45 1 1zm-7 17c-1.1 0-2-.9-2-2V9h12v12c0 1.1-.9 2-2 2h-8z"
                            fill="#6C727C"
                          /></svg
                        ></span
                      >
                    </div>
                    <svg
                      class="w-8 h-8 mx-auto"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      ><path
                        d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z"
                      /></svg
                    >

                    <span class="uppercase">Ganti Gambar</span><br />
                    {!dragging ? "Klik Disini" : "Ok Lepaskan"}
                  </div>
                </div>
              </FileInput>
            </div>
          </div>

          <div class="mt-5">
            <section class="mt-5">
              <label for="categories" class="relative">
                <div class="text-sm text-gray-800 themed">
                  <Select
                    optionIdentifier="value"
                    getSelectionLabel={(o) => o.label}
                    getOptionLabel={(option) =>
                      option.parent_index +
                      " > " +
                      option.parent +
                      " > " +
                      option.label}
                    items={categories.data}
                    placeholder="Pilih Kategori"
                    bind:selectedValue={require.category}
                  />
                  <span
                    class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                    id="category-labelwarning">Kategori</span
                  >
                  <span
                    class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                    id="category-warning"
                  />
                </div>
              </label>
            </section>

            <section class="mt-5">
              <label for="namaproduk" class="relative block text-sm font-light">
                <input
                  maxlength="70"
                  id="namaproduk"
                  type="text"
                  class="w-full text-sm placeholder-gray-400 border-gray-500 form-input hover:border-blue-400 focus:shadow-none"
                  placeholder="Contoh: Sepatu Pria (Jenis/Kategori Produk) + Tokostore (Merek) + Kanvas Hitam (Keterangan)"
                  bind:value={require.namaproduk}
                />
                <span
                  class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                  id="namaproduk-labelwarning"
                  >Nama Produk
                  <span class="my-2 text-xs text-right text-gray-500"
                    >{lengthCount}/70</span
                  ></span
                >
                <span
                  class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                  id="namaproduk-warning"
                />
              </label>
            </section>
            <section class="mt-5">
              <label
                for="berat"
                class="relative block text-sm font-light"
                id="berat-labelwarning"
              >
                <input
                  id="berat"
                  class="w-32 text-sm text-black placeholder-gray-400 border-gray-500 form-input hover:border-blue-400 focus:shadow-none"
                  type="text"
                  use:imask={GrNumber}
                  on:accept={beratMask}
                  placeholder={format("#.###,", require.berat)}
                  value={format("#.###,", require.berat)}
                />
                <span class="text-gray-600">gram</span><br />
                <span
                  class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                  id="berat-warning"
                />
                <span
                  class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                  id="berat-labelwarning">Berat</span
                >
              </label>
            </section>
            <section class="mt-5">
              <label for="harga" class="relative block text-sm font-light">
                <input
                  id="harga"
                  class="inline-block text-sm text-orange-600 placeholder-gray-400 border-gray-500 form-input hover:border-blue-400 focus:shadow-none w-46"
                  type="text"
                  use:imask={RpNumber}
                  on:accept={hargaMask}
                  placeholder={format("Rp #.###,", require.harga)}
                  value={format("Rp #.###,", require.harga)}
                /><br />
                <span
                  class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                  id="harga-labelwarning">Harga</span
                >
                <span
                  class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                  id="harga-warning"
                />
              </label>
            </section>

            <section class="mt-5 paragraphs">
              <label for="deskripsi" class="relative block text-sm font-light">
                <textarea
                  placeholder="Sepatu Sneakers Pria Tokostore Kanvas Hitam Seri C28B
- Model simple
- Nyaman Digunakan
- Tersedia warna hitam
- Sole PVC (injection shoes) yang nyaman dan awet untuk digunakan sehari - hari

Bahan:
Upper: Semi Leather (kulit tidak pecah-pecah)
Sole: Premium Rubber Sole

Ukuran
39 : 25,5 cm
40 : 26 cm
41 : 26.5 cm
42 : 27 cm
43 : 27.5 - 28 cm

Edisi terbatas dari Tokostore dengan model baru dan trendy untukmu. Didesain untuk bisa dipakai dalam berbagai acara. Sangat nyaman saat dipakai sehingga dapat menunjang penampilan dan kepercayaan dirimu. Beli sekarang sebelum kehabisan!"
                  maxlength="2000"
                  id="deskripsi"
                  class="w-full h-64 p-4 text-sm placeholder-gray-400 border border-gray-500 rounded-lg form-textarea hover:border-blue-400 focus:shadow-none"
                  bind:value={require.deskripsi}
                />
                <span
                  class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                  id="deskripsi-warning"
                />
                <span
                  class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                  id="deskripsi-labelwarning"
                  >Tentang Produk
                  <span class="my-2 text-xs text-right text-gray-500"
                    >{lengthDescriptionCount}/2000</span
                  ></span
                >
              </label>
            </section>

            <div data-controller="product">
              <span class="block pt-2 text-xs">&nbsp;</span>
              <form>
                <div
                  class="relative bottom-0 left-0 flex items-center justify-between w-full p-2 mt-2 h-18 lg:p-0"
                >
                  <button
                    on:click={() => window.history.go(-1)}
                    class="p-2 mx-1 text-sm text-gray-600 bg-orange-300 rounded-md focus:bg-gray-500 focus:outline-none"
                    type="button">Batal</button
                  >
                  <div>
                    <button
                      class="p-2 mx-1 text-sm text-white bg-green-600 rounded-md focus:bg-gray-500 focus:outline-none"
                      type="button"
                      on:click={handleSubmit}>Simpan</button
                    ><button
                      class="p-2 mx-1 text-sm text-white bg-blue-500 rounded-md focus:bg-gray-500 focus:outline-none"
                      type="button"
                      on:click={() => handleSubmit(1)}>& Tambah Baru</button
                    >
                  </div>
                </div>
              </form>
            </div>
            <div class="flex items-center justify-center my-5 lg:justify-end">
              {#if data}
                <Modal backdropClose size="lg:w-2/5 w-full">
                  <div slot="trigger" let:open>
                    <button
                      on:click={open}
                      class="p-2 mx-1 text-sm text-red-400 rounded-md focus:outline-none"
                      type="button">Hapus Produk</button
                    >
                  </div>
                  <div slot="header">
                    <h1 class="text-lg">Konfirmasi Penghapusan</h1>
                  </div>
                  <div slot="content" class="h-full">
                    <p>Apakah Anda yakin untuk menghapus produk ini ?</p>
                    <p class="text-gray-600">.. {require.namaproduk}</p>
                    <button
                      on:click={() => handleDelete()}
                      class="p-2 mx-1 mt-5 text-sm text-gray-100 bg-red-600 rounded-md focus:bg-gray-500 focus:outline-none"
                      type="button">Hapus Produk</button
                    >
                  </div>
                </Modal>
              {/if}
            </div>
          </div>
        </div>
      </div>
    </div>
  {/if}
</main>

<style>
  .themed {
    --border: 1px solid #a0aec0;
    --borderRadius: 0.25rem;
    --placeholderColor: #e2e8f0;
    --background: #fff;
    --inputFontSize: 0.875rem;
    --borderHoverColor: #63b3ed;
    --borderFocusColor: #63b3ed;
    --placeholderColor: #adb9c8;
    --itemIsActiveBG: #63b3ed;
  }
</style>
